import styled, { css } from 'styled-components';
export const InputBase = styled.div.attrs({
    className: 'input',
}) `
  display: inline-flex;
  flex-direction: column;
  position: relative;

  color: var(--color-on-background);
  font-family: 'Open Sans';
  font-size: 16px;
  line-height: 24px;

  &[aria-disabled='true'] {
    color: var(--color-disabled);
  }

  ${({ $fluid }) => $fluid &&
    css `
      width: 100%;
      max-width: 100%;

      & > ${Container} {
        width: 100%;

        & > select {
          width: 100%;
        }
      }
    `}

  & > .hint {
    margin: -8px 0 16px 0;
  }
`;
export const Label = styled.label `
  align-items: flex-start;
  display: flex;
  font-weight: 600;
  margin-bottom: 16px;
  word-wrap: break-word;

  > * {
    height: 24px;
  }
`;
export const NativeInput = styled.input `
  width: 100%;
  height: 40px;
  padding: 0 8px;
  border: none;
  box-sizing: border-box;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit;
  caret-color: var(--color-on-background);
  /* hide arrows on input type number start*/
  /* Chrome, Safari */
  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }

  /* Firefox */
  &[type='number'] {
    -moz-appearance: textfield; /* Firefox */
  }

  &:focus-visible {
    outline: none;
  }

  &:disabled {
    cursor: not-allowed;
    background: var(--color-on-primary);
    caret-color: var(--color-disabled);
    color: var(--color-disabled);
  }

  ${({ as: asProp }) => asProp === 'textarea' &&
    css `
      height: auto;
      padding: 8px;
    `}
`;
export const Container = styled.div `
  display: flex;
  align-items: center;
  align-self: flex-start;
  border-radius: 2px;
  border: 1px solid var(--color-on-background);
  background-color: var(--color-background);
  box-sizing: border-box;

  cursor: text;

  &:focus-within {
    border: 1px solid var(--color-selection);
    outline: 1px solid var(--color-selection);
  }

  ${({ $disabled }) => $disabled &&
    css `
      color: var(--color-disabled);
      border: 1px solid var(--color-disabled);
      cursor: not-allowed;
    `}

  ${({ $small, $large, $fluid }) => {
    if ($small)
        return css `
        width: 96px;
      `;
    if ($large)
        return css `
        width: 288px;
      `;
    if ($fluid)
        return css `
        width: 100%;
      `;
    return css `
      width: 148px;
    `;
}}

  ${({ $readOnly }) => $readOnly &&
    css `
      &:focus-within {
        outline: none;
      }
    `}

  ${({ $success, $warning, $error }) => {
    if ($success) {
        return css `
        outline: 2px solid var(--color-success-accent);
        border: 1px solid var(--color-success-accent);
      `;
    }
    if ($warning) {
        return css `
        outline: 2px solid var(--color-warning-accent);
        border: 1px solid var(--color-warning-accent);
      `;
    }
    if ($error) {
        return css `
        outline: 2px solid var(--color-error-accent);
        border: 1px solid var(--color-error-accent);
      `;
    }
    return '';
}}
`;
export const Suffix = styled.div `
  pointer-events: none;
  margin-right: 8px;
  white-space: nowrap;
`;
export const Additions = styled.div `
  display: flex;
  align-items: center;

  z-index: 1;

  > .icon-button {
    margin: 0 16px 0 8px;
  }
`;
